import { render, staticRenderFns } from "./SkuQuadrant.vue?vue&type=template&id=48f188f4&scoped=true"
import script from "./SkuQuadrant.vue?vue&type=script&lang=js"
export * from "./SkuQuadrant.vue?vue&type=script&lang=js"
import style0 from "./SkuQuadrant.vue?vue&type=style&index=0&id=48f188f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f188f4",
  null
  
)

export default component.exports